import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import WidgetContainer from '../WidgetContainer'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { formatDate, getDateFormat4 } from 'srcReact/helpers/datetimeHelper'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import { calWidgetActions } from './actions'
import AnchorLink from 'srcReact/components/common2/AnchorLink'
import Button from 'srcReact/components/common2/Button'
import Icon from 'srcReact/components/icons/Icon'
import LinkButton from 'srcReact/components/common2/LinkButton'

function Calendar({ groupId, isStaffMember, selectTab }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const maxMixrs = 3
  const [showAllMixrsButton, setShowAllMixrsButton] = useState(false)

  const {
    common: { userLocation },
    calWidget: { groupCalendar, loading, totalMixrs }
  } = useSelector((state) => state)
  const [mixrs, setMixrs] = useState([])

  useEffect(() => {
    if (groupId && userLocation) {
      const date = new Date()
      dayjs.extend(isBetween)

      dispatch(
        calWidgetActions.getMixrsOfGroupBetweenDays(
          groupId,
          null,
          null,
          maxMixrs,
          userLocation?.longitude,
          userLocation?.latitude,
          userLocation?.ip
        )
      )
      return () => {
        dispatch(calWidgetActions.setInitialState())
      }
    }
  }, [])

  useEffect(() => {
    if (groupCalendar?.length > 0) {
      const topNMixrs = []

      for (let i = 0; i < groupCalendar.length; i++) {
        for (let j = 0; j < groupCalendar[i].events?.length; j++) {
          if (!groupCalendar[i].events[j].is_over) {
            topNMixrs.push(groupCalendar[i].events[j])
          }
        }
      }
      setMixrs(topNMixrs)
      setShowAllMixrsButton(totalMixrs > topNMixrs.length)
    }
  }, [groupCalendar])

  // const handleActiveStartDateChange = ({ action, activeStartDate, value, view }) => {
  //   const date = new Date(activeStartDate)
  //   const startDate = formatDate(dayjs(date).startOf('month').toDate(), appConstantSettings.DATE_FORMAT8)
  //   const endDate = formatDate(dayjs(date).endOf('month').toDate(), appConstantSettings.DATE_FORMAT8)
  //   const latLong = getLatLong()
  //   dispatch(
  //     calWidgetActions.getMixrsOfGroupBetweenDays(
  //       groupId,
  //       startDate,
  //       endDate,
  //       latLong.longitude,
  //       latLong.latitude,
  //       userLocation?.ip
  //     )
  //   )
  // }
  // const handleChange = (value) => {
  //   const timestamp = dayjs.unix(value).unix()
  //   redirectToPage(`/0/home/group/${groupId}/mixrs-on-${timestamp}`)
  // }

  return (
    <WidgetContainer title={t('widgets.calendar.title')}>
      <div className={styles.calendarContainer}>
        {!loading ? (
          <React.Fragment>
            {mixrs.length === 0 ? (
              <div className={styles.noMixrs}>
                <p className={`${styles.mixr} ${styles.message}`}>{t('widgets.calendar.noMixrs')}</p>
                <LinkButton
                  customStyle={styles.btnCreateMixr}
                  size='large'
                  href={`/0/${groupId}/create-mixr`}
                  isReactLink={true}
                  text={isStaffMember ? t('global.planMixr') : t('global.suggestMixr')}
                />
              </div>
            ) : (
              <React.Fragment>
                {mixrs.map((mixr) => (
                  <AnchorLink
                    className={styles.mixr}
                    isReactLink={true}
                    isNative={false}
                    path={`/0/home/event/${mixr.mixr_id}`}>
                    <p className={styles.date}>{formatDate(mixr.event_start_converted_userTZ, getDateFormat4())}</p>
                    <p className={styles.mixrName}>{mixr.mixr_title}</p>
                  </AnchorLink>
                ))}
                {showAllMixrsButton && (
                  <Button
                    handleClick={() => selectTab('mixrs')}
                    text={t('global.allmixrs')}
                    customStyle={styles.btnAllMixrs}
                    iconPosition='end'
                    icon={<Icon name='arrow-right' size='large24' />}
                  />
                )}
              </React.Fragment>
            )}
          </React.Fragment>
        ) : null}

        {/* <ReactCalendar
          max-maxDetail='month'
          showNeighboringMonth={false}
          minDetail='month'
          className={`${styles.calendar}`}
          tileClassName={styles.tile}
          prev2Label={null}
          next2Label={null}
          formatShortWeekday={(locale, date) => formatDate(date, 'ddd')}
          formatMonthYear={(locale, date) => formatDate(date, 'MMMM YYYY')}
          onActiveStartDateChange={handleActiveStartDateChange}
          onChange={handleChange}
          tileContent={({ activeStartDate, date, view }) => {
            const tileCurrentDate = formatDate(date, appConstantSettings.DATE_FORMAT8)
            const currentDate = mixrs.find((m) => m.date === tileCurrentDate)
            let mixrsOnDate = currentDate ? currentDate.events : []
            const going = []
            const notGoing = []

            if (mixrsOnDate && mixrsOnDate.length > 0) {
              mixrsOnDate.forEach((mixr) => {
                const status = mixr.user_attending_type
                if (status === 'in_person' || status === 'virtual' || status === 'going') {
                  going.push(mixr)
                } else {
                  notGoing.push(mixr)
                }
              })

              return (
                <React.Fragment>
                  {mixrsOnDate.length > 0 && (
                    <div className={styles.statusContainer}>
                      {going.length > 0 && (
                        <div
                          className={`${styles.goingContainer} ${notGoing.length === 0 && styles.goingFullContainer}`}>
                          {going.map((mixr, index) => {
                            return (
                              index < 3 && (
                                <TooltipWrapper
                                  content={mixr.mixr_title}
                                  triggerElement={
                                    <div
                                      className={`${styles.going} ${
                                        mixrsOnDate.length <= 2 || notGoing.length === 0
                                          ? styles.noOverlap
                                          : index !== 0 && notGoing.length != 0
                                          ? styles[`going${index}`]
                                          : ''
                                      }`}
                                    />
                                  }
                                />
                              )
                            )
                          })}
                        </div>
                      )}
                      {notGoing.length > 0 && (
                        <div
                          className={`${styles.notGoingContainer} ${
                            going.length === 0 && styles.notGoingFullContainer
                          }`}>
                          {notGoing.map(
                            (mixr, index) =>
                              index < 3 && (
                                <TooltipWrapper
                                  content={mixr.mixr_title}
                                  triggerElement={
                                    <div
                                      className={`${styles.notgoing} ${
                                        mixrsOnDate.length <= 2 || going.length == 0
                                          ? styles.noOverlap
                                          : index !== 0 && going.length != 0
                                          ? styles[`notgoing${index}`]
                                          : ''
                                      }`}
                                    />
                                  }
                                />
                              )
                          )}
                        </div>
                      )}
                    </div>
                  )}
                  {isToday(date) && <div className={styles.today} />}
                </React.Fragment>
              )
            }
            return isToday(date) && <div className={styles.today} />
          }}
        /> */}
      </div>
    </WidgetContainer>
  )
}

export default Calendar
